/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your signature online for free. Draw with your mouse or trackpad, or type your name in a handwriting font, then download a transparent PNG.`)
};

const es_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tu firma en línea de forma gratuita. Dibuja con tu ratón o panel táctil, o escribe tu nombre en una fuente de escritura manual, luego descarga un PNG transparente.`)
};

const de_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie kostenlos Ihre Signatur online. Zeichnen Sie mit Ihrer Maus oder Ihrem Trackpad, oder geben Sie Ihren Namen in einer Handschriftschrift ein, und laden Sie dann ein transparentes PNG herunter.`)
};

const nl_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak uw handtekening online gratis. Teken met uw muis of trackpad, of typ uw naam in een handschriftstijl, en download een transparante PNG.`)
};

const fr_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre signature en ligne gratuitement. Dessinez avec votre souris ou votre trackpad, ou tapez votre nom dans une police manuscrite, puis téléchargez un PNG transparent.`)
};

const it_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea la tua firma online gratuitamente. Disegna con il tuo mouse o trackpad, oppure digita il tuo nome in un carattere calligrafico, poi scarica un PNG trasparente.`)
};

const pt_br2_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie sua assinatura online gratuitamente. Desenhe com seu mouse ou trackpad, ou digite seu nome em uma fonte cursiva, depois baixe um PNG transparente.`)
};

const pt_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie a sua assinatura online gratuitamente. Desenhe com o rato ou trackpad, ou escreva o seu nome com uma fonte de caligrafia, depois descarregue um PNG transparente.`)
};

const ja_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で署名を作成します。マウスまたはトラックパッドで描くか、手書きフォントで名前を入力してから、透明なPNGをダウンロードします。`)
};

const zh_sig_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线创建您的签名。用鼠标或触控板绘制，或用笔迹字体输入您的名字，然后下载透明 PNG。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_meta_description", locale)
	if (locale === "en") return en_sig_hub_meta_description(inputs)
	if (locale === "es") return es_sig_hub_meta_description(inputs)
	if (locale === "de") return de_sig_hub_meta_description(inputs)
	if (locale === "nl") return nl_sig_hub_meta_description(inputs)
	if (locale === "fr") return fr_sig_hub_meta_description(inputs)
	if (locale === "it") return it_sig_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_meta_description(inputs)
	if (locale === "pt") return pt_sig_hub_meta_description(inputs)
	if (locale === "ja") return ja_sig_hub_meta_description(inputs)
	return zh_sig_hub_meta_description(inputs)
};